import { Component, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from '@app/core/services/toast/toast.service';
import { BuildTypeLogicService } from '@app/logic/build-type';
import { DesignComplexityLogicService } from '@app/logic/design-complexity';
import { IDesignSchemeMappedItem } from '@app/logic/design-schemes';
import { IDesignSchemesLogicService } from '@app/logic/design-schemes/interfaces/i.design-schemes-logic.service';
import { ILotMappedItem } from '@app/logic/lots';
import { StandardPlanLogicService } from '@app/logic/standard-plans';
import { CbDialogService } from '@app/shared/components/dialog/cb-dialog.service';
import { DesignComplexityDialogFormViewBase } from '../../../shared/design-complexity-dialog-form-view.base';
import { toPromisedArray } from 'cb-hub-lib';
import { IDesignSchemeDto } from '@classictechsolutions/hubapi-transpiled-enums';
import { take } from 'rxjs';

@Component({
    selector: 'cb-finalise-dialog',
    templateUrl: './finalise-dialog.component.html',
    styleUrls: ['./finalise-dialog.component.scss'],
    standalone: false
})
export class DesignSchemeFinaliseDialogComponent extends DesignComplexityDialogFormViewBase<IDesignSchemeDto, IDesignSchemeMappedItem, IDesignSchemesLogicService> {
    public static readonly MIN_WIDTH = '66%';
    public buildTypes = toPromisedArray(this.buildTypeLogic.getListByLotType(this.data.lotMappedItem.lotType));
    public standardPlans = toPromisedArray(this.standardPlanLogic.$getList());

    public get mappedItem(): IDesignSchemeMappedItem {
        return this.data.mappedItem;
    }

    constructor(
        public readonly dialogRef: MatDialogRef<DesignSchemeFinaliseDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: {
            mappedItem: IDesignSchemeMappedItem;
            lotMappedItem: ILotMappedItem;
        },
        @Inject(CbDialogService) private readonly cbDialog: CbDialogService,
        @Inject(BuildTypeLogicService) private readonly buildTypeLogic: BuildTypeLogicService,
        @Inject(StandardPlanLogicService) private readonly standardPlanLogic: StandardPlanLogicService,
        @Inject(DesignComplexityLogicService) designComplexityLogicService: DesignComplexityLogicService,
        public toastService: ToastService
    ) {
        super(dialogRef, toastService, designComplexityLogicService);
        this.loadDesignComplexities(this.mappedItem.designComplexity?.id ?? 0);
    }

    public isSaveDisabled(form: NgForm): boolean {
        return form.invalid;
    }

    public updatedDesignComplexity(selectedId: number): void {
        this.loadDesignComplexities(selectedId ?? 0);
    }

    public confirmSubmitScheme(): void {
        this.cbDialog
            .confirm({
                dialogHeading: 'Submit Design Scheme',
                message: 'Are you sure you want to submit this Design Scheme?',
                confirmed: () => {
                    this.mappedItem
                        .$save()
                        .pipe(take(1)).subscribe(result => this.dialogRef.close(result));
                }
            });
    }
}
